<template>
    <div>
        <div class="wrapper text text--align-center">
            <div class="box__container" style="margin-top: 70px; margin-bottom: 10px;">

                <div id="backgroundBoxFirst" class="box box--workout box--first">
                    <div style="height: 10%" class="box__background"></div>
                </div>

                <div id="backgroundBoxSecond" class="box box--workout box--second">
                    <div class="box__background"></div>
                </div>
            </div>
            <span class="text text--big text--red number">
                <strong id="shakeCountElem">00</strong>
            </span>
            <p class="text text--red margin margin--bottom-20 text-info">
                <span v-html="currentData.copyRed"></span>
                <span id="afterFirstActionCorrect" style="display: none;" v-html="currentData.copyRedAfterFirstCorrect"></span>
            </p>
            <button class="button" disabled="disabled" id="nextButton" v-if="stock">
                <router-link :to="'/activityType/' + this.$route.params.id + '/form'">{{currentData.buttonCopy}}</router-link>
            </button>
            <button class="button button-home" disabled="disabled" id="nextButton" v-if="!stock">
                <router-link :to="'/'">ZURÜCK ZUR STARTSEITE</router-link>
            </button>

        </div>

        <svg width="0" height="0">
            <defs>
                <clipPath id="arrow">
                    <polygon points="0 53.5219022 22.4368652 75.9587674 35.6207914 62.8353179 35.6207914 145.144142 71.9068268 145.144142 71.9068268 62.8353179 85.3931366 76.2551034 107.830002 53.8182382 53.7638091 0"></polygon>
                </clipPath>
            </defs>
        </svg>
    </div>

</template>
<script>

    import data from '../assets/data/data'

    import Shake from '../../js/shake.js';
    import scripts from '../../js/scripts.js';
    import config from '../assets/data/config.json';
    import axios from 'axios';

    export default {
        name: 'GameWorkout',
        data: function () {
            return {
                data: data,
                stock: false,
                availableData:  {
                    yoga: {
                        availableCount: 0
                    },
                    workout: {
                        availableCount: 0
                    },
                    running: {
                        availableCount: 0
                    }
                }
            }
        },
        mounted: function(){
            axios.get(config.endpoint.available).then(response => {

                if(response.data.availableData){
                    this.availableData = response.data.availableData;
                }
                this.checkAvailableProducts();


            }).catch((e) => {

            });

            var _this = this;

            window.shaker = new window.Shaker();
            window.shaker.init();
            window.addEventListener('permissionDeniedMicEvent', _this.onPerms, false);

        },
        computed: {

            currentData: function () {
                return this.data.activities[this.$route.params.id].game;
            }
        },
        methods: {

            onPerms: function(){
                this.$router.push({ path: '/alert' });
            },
            checkAvailableProducts: function () {

                const allProducts = this.availableData;
                const emptyProducts = Object.keys(allProducts).filter(keyName => {
                    let currentValue = allProducts[keyName];
                    return currentValue.availableCount < 1
                });

                if(emptyProducts.length == Object.keys(allProducts).length) {

                } else {
                    this.stock = true;
                }

            }

        },
        beforeDestroy: function(){

            var _this = this;

            window.shaker.destroy();
            window.shaker = undefined;
            window.removeEventListener('permissionDeniedMicEvent', _this.onPerms);
        }

    }


</script>

<style lang="scss" scope="local">

    .box__container{
        max-width: 227px;
    }

    .box--workout {

        position: relative;
        width: 150px;
        height: 150px;

        margin: auto;
        transform: translateZ(0);
        -webkit-clip-path: url(#arrow);
        clip-path: url(#arrow);

        background-color: #e1e2dc;

        &.box--first {

            transform: rotate(180deg);

        }

        &.box--running {


            .box__background {

                bottom: auto;
                top: 0;

            }

        }

    }
</style>
